<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-12-11 18:06:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-07-31 13:58:15
 * @FilePath: \vue-new-hepha\src\views\Login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="container">
        <div class="bg"></div>

        <!-- <div class="lang">
            <GlobalOutlined style="margin-right:5px;font-size:20px;color:#1226aa;"/>
            <a-select
                ref="select"
                v-model:value="lang"
                style="width: 120px"
                :options="options"
                @change="(val)=>handleChange(val)"
            ></a-select>
        </div> -->

        <!-- <div class="setLang">
            <div class="earthIcon">
                <img  src="@/assets/image/earth.png" alt="" width="25" height="25">
            </div>
            <a-select 
                class="setLangSelect"
                v-model:value="lang" 
                :bordered="false"
                @change="(val,opt)=>changeSelect(val,opt)"
            >
                <a-select-option value="en">English</a-select-option>
                <a-select-option value="de">Deutsch</a-select-option>
            </a-select>
        </div> -->

        <div class="content">
            <div class="logo">
                <img src="@/assets/image/logo_large.svg" alt="" width="280">
            </div>

            <div class="descBlock">
                <div class="desc">{{ $t('login.desc') }}</div>
                <div class="subDesc">{{ $t('login.subDesc') }}</div>
            </div>

            <div class="form">
                <div class="form_dialog">
                    <div class="form_item">
                        <div class="label">{{ $t('login.email_address') }} <span class="required">*</span></div>
                        <a-input v-model:value="form.email" />
                    </div>
                    <div class="form_item">
                        <div class="label">{{ $t('login.password') }} <span class="required">*</span></div>
                        <a-input-password  v-model:value="form.password" />
                    </div>
                    <div class="form_item remember-row">
                        <a-checkbox v-model:checked="form.remember" style="margin-right:8px;"></a-checkbox>{{ $t('login.rememberPassword') }}
                    </div>
                    <div class="form_item privacy_row">
                        <a-checkbox v-model:checked="privacy" style="margin-right:5px;"></a-checkbox>
                        {{ $t('login.readAgreed') }} <a href="https://open.gobao-ebike.com/policy/privacy" target="_bland" class="privacy">{{ $t('login.privacy') }}</a> 
                        {{ $t('login.and') }} <a href="https://open.gobao-ebike.com/policy/warranty" target="_bland" class="privacy">{{ $t('login.serviceTerm') }}</a>
                    </div>
                    <div class="formFooter">
                        <a-button class="loginBtn" type="primary" :disabled="!privacy" @click="beforeLogin">{{ $t('login.login') }}</a-button>
                        <div class="forgotPassword">
                            <span class="forgotPasswordBtn" @click="forgotPassword">{{ $t('login.forgotPassword') }}</span> 
                        </div>
                    </div>
                </div>
            </div>

            <Verify
                class="verify"
                @success="success" 
                mode="pop" 
                captchaType="blockPuzzle"
                :imgSize="{ width: '408px', height: '155px' }"
                ref="verifyRef"
            ></Verify>
        </div>

        <!-- 品牌弹窗 -->
        <a-modal 
            v-model:open="visible" 
            :width="550" 
            centered
            :title="t('login.selectTenant')"
            :footer="null"
        >
            <div class="tenantList">
                <div class="selectTenantTip">{{ t('login.selectTenantTip') }}</div>
                <div v-for="(item,index) in tenant_list" :key="index" class="tenantList_item" @click="loginByTenant(item)">
                    <div class="tenantList_item_left">
                        <img :src="item.smallLogoIcon" alt="" width="40" height="40">
                    </div>
                    <div class="tenantList_item_center">
                        <div class="tenant_name">{{ item.tenant_name }}</div>
                        <div class="user_name">
                            <span class="user_name_text">{{ loginUserInfo.user_name }}</span> 
                            <a-tag class="status_tag" :color="item.tenant_user_status == 0? 'success' : item.tenant_user_status == 1? 'default' : 'error'">
                                <template #icon>
                                    <check-circle-outlined v-if="item.tenant_user_status == 0" />
                                    <exclamation-circle-outlined v-if="item.tenant_user_status == 1" />
                                    <minus-circle-outlined v-if="item.tenant_user_status == 2" />
                                </template>
                                {{ item.tenantUserStatus_text }}
                            </a-tag>
                        </div>
                    </div>
                    <RightOutlined class="tenantList_item_right" :style="{fontSize:'30px', color:'#ccc'}"/>
                    
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, watch} from "vue";
    // import Table from "@/components/Table.vue";
    // import Form from "@/components/Form.vue";
    // import { QueryForm } from './config/QueryConfig.js';
    import { useRoute, useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { LoginApi } from '@/api/LoginApi.js';
    import { GlobalOutlined } from '@ant-design/icons-vue';
    import jwt_decode from "jwt-decode";
    import { useThrottleFn } from '@vueuse/core'
    import { useStore } from '@/store/index.js';
    import Verify from "@/components/verifition/Verify";

    const store = useStore()
    const i18n = useI18n()
    const { t } = useI18n()
    const router = useRouter()
    const route = useRoute()

    const lang = !localStorage.getItem('app_console_lang')? ref('en') : ref(localStorage.getItem('app_console_lang'))
    const form = reactive({
        email: localStorage.getItem('newappconsole_remembered_email') || '',
        password: localStorage.getItem('newappconsole_remembered_password') || '',
        remember: localStorage.getItem('newappconsole_remember_password') === 'true'
    })
    const loginUserInfo = ref(null)
    const tenant_list = ref([])
    const login_token = ref('')
    const visible = ref(false)
    const privacy = ref(false)

    const verifyRef = ref(null)
    const captcha_verification = ref('')


    // 切换语言
    const changeSelect = (val)=>{
        localStorage.setItem('app_console_lang', val)
        i18n.locale.value = val
        store.changeLang(val)
    }

    const beforeLogin = ()=>{
        if(!form.email){
            message.error(t('login.email_address') + ' ' + t('base.noEmpty'))
            return
        }else if(!form.password){
            message.error(t('login.password') + ' ' + t('base.noEmpty'))
            return
        }

        console.log(captcha_verification.value,'captcha_verification 999999999999')
        if(captcha_verification.value == ''){
            verifyRef.value.show()
            return
        }
    }

    // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    const success = (params)=>{ 
        console.log(params,'params')
        captcha_verification.value = params.captchaVerification
        login()
    }

    // 登录
    const login = useThrottleFn(async()=>{
        // if(!form.email){
        //     message.error(t('login.email') + ' ' + t('base.notEmpty'))
        //     return
        // }else if(!form.password){
        //     message.error(t('login.password') + ' ' + t('base.notEmpty'))
        //     return
        // }
        
        let param = {
            user_name: form.email,
            password: form.password,
            captcha_verification: captcha_verification.value
        }
        let res = await LoginApi.getInstance().login(param)
        if(res.code == 0){
            loginUserInfo.value = jwt_decode(res.access_token)
            login_token.value = res.access_token
            visible.value = true
            captcha_verification.value = ''
            sessionStorage.setItem('token',res.access_token)
            getTenantList()
        }else{
            message.error(res.msg || res.message)
            captcha_verification.value = ''
        }
    }, 2000)


    // 选择品牌后登录
    const loginByTenant = useThrottleFn(async (item)=>{
        // 处理记住密码
        if (form.remember) {
            localStorage.setItem('newappconsole_remembered_email', form.email)
            localStorage.setItem('newappconsole_remembered_password', form.password)
            localStorage.setItem('newappconsole_remember_password', 'true')
        } else {
            localStorage.removeItem('newappconsole_remembered_email')
            localStorage.removeItem('newappconsole_remembered_password')
            localStorage.removeItem('newappconsole_remember_password')
        }

        let param = {
            code: item.tenant_code,
            user_id: loginUserInfo.value.id,
            tenant_id: item.tenant_id,
        }
        let res = await LoginApi.getInstance().loginByTenant(param, loginUserInfo.value.id, item.tenant_id)
        if(res.code == 0){
            let userInfo = jwt_decode(res.access_token)
            let baseRoleId = ''
            baseRoleId = import.meta.env.VITE_BASE_URL.trim() == 'https://sit.gobao-ebike.com' ? '331':(import.meta.env.VITE_BASE_URL.trim() == 'https://open.gobao-ebike.com' ? '71':'')
            if(userInfo.role === baseRoleId){
                message.error(t('login.noPermissionLogin'))
                visible.value = false
                return;
            }            
            message.success(t('login.loginSucceeded'))
            sessionStorage.setItem('token',res.access_token)
            sessionStorage.setItem('userInfo',JSON.stringify(userInfo))
            sessionStorage.setItem('logo', JSON.stringify({'logo': res.logo_icon, 'small_logo':res.small_logo_icon}))
            store.changeUserInfo(userInfo)
            router.push('/Home')
        }else if(res.code == 1011){
            Modal.confirm({
                title: t('base.tip'),
                content: t('login.noActiveTip'),
                width: 500,
                okText: t('login.resend'),
                cancelText: t('base.cancel'),
                onOk:()=>{
                    resendEmail()
                },
            });
        }else{
            message.error(res.msg || res.message)
        }
    }, 2000) 

    // 登录时获取租户列表
    const getTenantList = async()=>{
        let res = await LoginApi.getInstance().getTenantList(loginUserInfo.value.id)
        if(res.code == 0){
            res.data.forEach(i=>{
                i.tenantUserStatus_text = i.tenant_user_status == 0? t('login.normal') : t('login.noAvive')
                i.smallLogoIcon = i.small_logo_icon
            })
            tenant_list.value = res.data
        }
    }

    // 忘记密码
    const forgotPassword = ()=>{
        router.push('/ForgotPassword')
        // router.push({path: '/ForgotPassword', query: {type: 'reset'}}) // 模拟邮件跳转重置密码
    }

    // 重新发送邮件
    const resendEmail = async()=>{
        let res = await LoginApi.getInstance().resendEmail(loginUserInfo.value.id)
        if(res.code == 0){
            message.success(t('base.sendSucceeded'))
            visible.value = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    onMounted(()=>{
        console.log(import.meta.env.VITE_BASE_URL,'环境')
    })
    
</script>

<style lang="scss" scoped>
.container{
    height: 100%;
    overflow-y: scroll;
    background: linear-gradient(-45deg, #f7f6f9 0%, #f7f6f9 50%, #c4dafd 100%);

    .lang{
        position: absolute;
        right: 50px;
        top: 10px;
    }

    .setLang{
        position: fixed;
        top: 10px;
        
        .earthIcon{
            position: fixed;
            right: 170px;
            padding-left: 5px;
            width: 30px;
            height: 32px;
            background: #1226aa;
            img{
                display: inline-block;
                margin-top: 3px;
            }
        }

        .setLangSelect{
            position: fixed;
            // top: 30px;
            right: 50px;
            width: 120px;
            background: #1226aa;
            color:#fff;
        }
    }

    ::v-deep .ant-select-single .ant-select-selector,
    ::v-deep .ant-select .ant-select-arrow,
    ::v-deep .ant-select-single.ant-select-open .ant-select-selection-item{
        color:#fff !important;
    }

    .content{
        position: absolute;
        // top: 50%;
        left: 50%;
        z-index: 1;
        // margin-top: -300px;
        margin-left: -300px;
        padding:100px 0 50px;

        .logo{
            margin: 10px auto 50px;
            width: 100%;
            text-align: center;
        }

        .descBlock{
            margin-bottom: 30px;
            width: 100%;
            text-align: center;

            .desc{
                font-weight: 700;
                font-size: 18px;
            }

            .subDesc{
                font-size: 18px;
                color: #333;
            }
        }
    }

    // 表单
    .form{
        padding: 30px;
        width: 600px;
        border-radius: 5px;
        // background: #fff;
        // box-shadow: 1px 1px 18px -12px #000;

        .form_item{
            margin: 0 0 20px 0;
            .label{
                margin-bottom: 3px;
                font-size: 16px;
                font-weight: 700 !important;
            }
            .required{
                color: red;
            }
            &.remember-row {
                margin-bottom: 10px;
            }

            .privacy{
                color: #1226AA;
            }

            .privacy:hover{
                text-decoration: underline;
            }
        }

        .formFooter{
            text-align: center;

            .loginBtn{
                margin: 20px 20px 15px 20px;
                width: 170px;
                height: 40px;
                outline: none;
            }

            .forgotPassword{
                margin: 0 0 10px 0;
                font-size: 15px;

                .forgotPasswordBtn{
                    cursor: pointer;
                }

                .forgotPasswordBtn:hover{
                    text-decoration: underline;
                    color: #1226aa;
                }
            }
            
        } 
    }
}



::v-deep button:hover {
    border-color: transparent;
}

::v-deep .ant-input{
    height: 50px;
}

::v-deep .ant-input-affix-wrapper >input.ant-input{
    height: 40px;
}

.tenantList{
    text-align: left;

    .selectTenantTip{
        margin-top: 30px;
        color: #666;
    }

    .tenantList_item{
        display:flex;
        margin: 10px 0;
        padding: 10px 30px;
        background: #f4f4f4;
        border-radius: 5px;
        border: 1px solid #f4f4f4;

        .tenantList_item_left{
            display:flex;
            margin-right: 30px;
            padding: 7px;
            background: #fff;
            border-radius: 10px;
        }

        .tenantList_item_center{
            display:flex;
            flex:3;
            flex-direction: column;

            .tenant_name{
                font-size: 18px;
                font-weight: 600;
            }

            .user_name{
                position: relative;
                font-weight: normal;

                .user_name_text{
                    display: inline-block;
                    width:180px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .status_tag{
                    position: absolute;
                    top: -11px;
                    right: -55px;
                }
            }
        }

        .tenantList_item_right{
            display:flex;
            flex:1;
            justify-content: flex-end;
        }
    }

    .tenantList_item:hover{
        border: 1px solid #1226AA;
        cursor: pointer;
    }
}
</style>